import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import moment from 'moment';

import { CenterpieceWhiteLogo } from '../../../components/logos/CenterpieceWhiteLogo';

interface HeaderProps {
  date?: Date;
  caption?: any;
}

export const Header = ({ date, caption }: HeaderProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        bgcolor: '#163B3F', //theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        display: 'flex',
        alignItems: 'center',
        paddingY: 3.5,
        paddingX: 4.5,
      }}
    >
      <Box>
        <CenterpieceWhiteLogo />
        {caption}
      </Box>
      {date && (
        <Box
          sx={{
            textAlign: 'right',
            marginLeft: 'auto',
          }}
        >
          <Typography variant="caption">Due Date</Typography>
          <Typography variant="body2">
            {moment(date).format('MM/DD/YYYY')}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
